import React from 'react';
import { useRouteData, useSiteData, Head } from 'react-static';

import Page from '@nmx/template/dist/componentLibrary/layout/Page';
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import DescriptionList from '@nmx/template/dist/componentLibrary/components/DescriptionList';

// local components
import VariableProductsFootnotes from '../components/variableProductsFootnotes';
import FundDetailsForm from '../components/fundDetailsForm';

export const descriptionListConfig = [{
  descriptionTerm: 'Value:',
  descriptionDetails: (<>Value managers are generally more interested in getting a company&#39;s stock for a good price&#59; they purchase stocks of companies that are currently out of favor with the market, believing that the stock is a good value for the price.</>),
}, {
  descriptionTerm: 'Blend:',
  descriptionDetails: 'Blend managers may take meaningful positions in growth or value stocks, but usually exhibit no strong bias toward either style.',
}, {
  descriptionTerm: 'Growth:',
  descriptionDetails: (<>Growth managers typically concentrate on companies with outstanding prospects for future growth; they seek companies with a record of consistent, above&#45;average profitability, or those expected to generate above&#45;average earnings growth.</>),
}, {
  descriptionTerm: 'Large Cap:',
  descriptionDetails: (<>Generally companies that have a market capitalization larger than &#36;10 billion.</>),
}, {
  descriptionTerm: 'Mid Cap:',
  descriptionDetails: (<>Generally companies that have a market capitalization between &#36;3 and &#36;10 billion. Mid&#45;size company&#39;s may involve greater risks than stocks of companies with larger capitalizations because they often have a more limited track record, have narrower markets for their products and services and more limited managerial and financial resources than larger, more established companies.</>),
}, {
  descriptionTerm: 'Small Cap:',
  descriptionDetails: (<>Generally companies that have a market capitalization smaller than &#36;3 billion. Small company&#39;s may involve greater risks than stocks of companies with larger capitalizations because they often have a more limited track record, have narrower markets for their products and services and more limited managerial and financial resources than larger, more established companies. Also, to a lesser degree than mid&#45;size companies, face greater risk of failure.</>),
}, {
  descriptionTerm: 'International:',
  descriptionDetails: ('Generally invest assets in securities whose primary trading markets are outside of the United States. Note that foreign investments involve greater risks than U.S. investments. These risks, especially in emerging markets, include political and economic uncertainties of foreign countries as well as the risk of currency fluctuations.'),
}];

export default () => {
  const { config, dynamicConfig } = useSiteData();
  const { pageProps } = useRouteData();
  const disclaimer = VariableProductsFootnotes();

  return (
    <Page
      {...pageProps} // defined in route.js
      headComponent={Head}
      dynamicConfig={dynamicConfig}
      config={config}
      customDisclaimers={[
        disclaimer,
      ]}>
      <SectionContainer
        id='equity-definitions-header-section'
        backgroundVariant='lightA'
        themeType='lightTheme'>
        <Typography
          component='h1'
          align='center'>
          Equity Definitions
        </Typography>
      </SectionContainer>
      <FundDetailsForm /> {/* Used on all underlying funds pages */}
      <SectionContainer
        id='equity-definitions-overview-section'
        backgroundVariant='lightA'
        themeType='lightTheme'>
        <Row align='center'>
          <Col medium={8}>
            <DescriptionList descriptionListData={descriptionListConfig} disableBullet />
          </Col>
        </Row>
      </SectionContainer>
    </Page>
  );
};
